const LOG_PREFIX = '[Landing]';

const fetchProductsQueryKey = 'fetch-articles-by-categories-query-fn';

export default {
  LOG_PREFIX,
  fetchProductsQueryKey,
};
